import React, { useContext, useEffect, useCallback } from "react";
import {Form, Input, Button, Row, Col, Modal, notification, Select, Switch, Space} from "antd";
import axios from "axios";
import GlobalContext from "../../utils/GlobalContext";
import mergeProps from "../../utils/MergeProps";
import moment from "moment";
import formatTimestamp from "../../utils/FormatTimestamp"
const { TextArea } = Input;
const { Option } = Select;

const AgreementActionForm = ({
  open,
  onFinish,
  onCancel,
  isEdit,
  currentMeetingPointDetail,
  currentAgreement,
  currentMeeting,
}) => {
  const globals = useContext(GlobalContext);
  const [form] = Form.useForm();
  const [implementationData, setImplementationData] = React.useState(false);
  const [nextMeetings, setNextMeetings] = React.useState([]);
  const isLastRecurrentMeeting = currentMeeting?.periodicity_group_id == null || nextMeetings.length === 0;

  const userEmail = globals.userEmail;
  const isOwner = currentMeeting?.creator === userEmail;
  const isCohost = currentMeeting?.co_host === userEmail;
  const isResponsiblePoint = currentMeetingPointDetail?.responsible === userEmail;
  const isResponsibleAgreement = currentAgreement?.responsible === userEmail;
  const isExecutor = currentAgreement?.executor === userEmail;

  const allowEdit = isOwner || isCohost || isResponsiblePoint || isResponsibleAgreement || isExecutor;

  const fetchNextMeetings = useCallback(async () => {
    try {
      if (!currentMeeting) return;
      await new Promise((resolve) => setTimeout(resolve, 100));
      const response = await axios.get(
        `${globals.SERVICE_API_DB}/v1/list-later-meeting/${currentMeeting?.id}`,
        {
          headers: {
            "x-token": globals.token,
          },
        }
      );
      setNextMeetings(response?.data?.data);
    } catch (error) {
      if (error?.response?.data?.status === -2){
        setNextMeetings([]);
        return;
      }
      console.error("Error fetching next meetings:", error);
      notification.error({
        message: "Error obteniendo siguientes reuniones",
        placement: "bottomRight",
      });
    }
    // setLoadingClients(false);
  }, [globals.SERVICE_API_DB, globals.token, currentMeeting]);

  useEffect(() => {
    fetchNextMeetings();
  }, [fetchNextMeetings, currentMeeting]);

  useEffect(() => {
    if (isEdit) {
      form.setFieldsValue({
        date: (currentAgreement) ? moment(currentAgreement?.date).format("YYYY-MM-DD") : null,
        criterion: currentAgreement?.criterion,
        responsible: currentAgreement?.responsible,
        executor: currentAgreement?.executor,
        observation: currentAgreement?.observation,
        implementationDate: (currentAgreement) ? moment(currentAgreement?.implementationDate).format("YYYY-MM-DD") : null,
        next_meeting_Id: currentAgreement?.next_meeting_Id,
      });
      setImplementationData(currentAgreement?.implementation);
    }
    else{
      form.resetFields();
    }
  }, [isEdit, form, currentAgreement, open]);

  const handleComplete = async (values) => {
    try {
      if (currentMeeting?.periodicity_group_id === null) {
        values.next_meeting_Id = null
      }

      if (values.date < currentMeeting?.startDate) {
        notification.error({
          message: "La fecha planificada no puede ser anterior a la fecha de la reunión",
          placement: "bottomRight",
        });
        return;
      }
      
      let newDate = moment(values.date);
      let now = moment();

      newDate = newDate.set({hour: now.hour(), minute: now.minute(), second: now.second(), millisecond: now.millisecond()});
      
      values.date = newDate.toISOString();

      if (isEdit) {
        let request = getRequest();
        request = {...request, ...values};
        request.implementation = (implementationData) ? 1 : 0;
        request.meetingPointDetailId = currentMeetingPointDetail.id;
        if (request.implementationDate === "Invalid date" || request.implementationDate === null){
          request.implementationDate = null;
        }
        console.log("request edit", request);
        const response = await axios.put(
          `${globals.SERVICE_API_DB}/v1/update-agreements/${currentAgreement.id}`,
          request,
          {
            headers: {
              "x-token": globals.token,
            },
          }
        );
        console.log(response);
        if (response?.data?.status === 0) {
          currentAgreement = mergeProps(
            currentAgreement,
            response?.data?.data
          );
          console.log("currentAgreement", currentAgreement);
          onFinish({ status: "edited" });
        }
        form.resetFields();
        return;
      }
      
      let request = getRequest();
      const filteredValues = Object.keys(values)
      .filter(key => values[key] !== null && values[key] !== undefined)
      .reduce((obj, key) => {
        obj[key] = values[key];
        return obj;
      }, {});
      request = {...request, ...filteredValues};
      request.meetingPointDetailId = currentMeetingPointDetail.id;
      request.implementation = (implementationData) ? 1 : 0;
      console.log("request", request);
      await axios.post(
        `${globals.SERVICE_API_DB}/v1/create-agreements`,
        request,
        {
          headers: {
            "x-token": globals.token,
          },
        }
      );
      onFinish({ status: "created"});
      form.resetFields();
    } catch (error) {
      console.error("Error submitting form:", error);
      notification.error({
        message: "Error guardando acuerdo",
        placement: "bottomRight",
      });
    }
  };

  const handleCancel = () => {
    form.resetFields();
    onCancel();
  };

  const getRequest = () => {
    return {
      "executor": "",
      "implementation": 0,
      "observation" : "",
      "result": "",
      "implementationDate": null,
      "successful": 0,
    }
  }

  return (
    <Modal
      title={isEdit ? "Ver acuerdo con acción" : "Crear acuerdo de acción"}
      open={open}
      onCancel={handleCancel}
      footer={null}
    >
      <Form form={form} layout="vertical" onFinish={handleComplete}>
        <span style={{fontWeight: "bold"}}>Punto de reunión: </span><span>{currentMeetingPointDetail?.name}</span>
        <hr />
        <Row gutter={16}> 
          <Col span={12}>
            <Form.Item
                name="date"
                label="Fecha planificada"
                rules={[
                  {
                    required: true,
                    message: "Por favor ingrese la fecha planificada",
                  },
                ]}
              >
                <Input 
                  type="date"
                  disabled={!allowEdit}
                />
              </Form.Item>
          </Col>
          <Col span={12}>
          <Form.Item
            name="next_meeting_Id"
            label="Reunión donde se revisará"
            rules={[
              {
                required: (isLastRecurrentMeeting) ? false : true,
                message: "Por favor seleccione la próxima reunión",
              },
            ]}
          >
            <Select 
              placeholder="Seleccione una próxima reunión"
              disabled={!allowEdit}
            >
              {nextMeetings.map((meeting) => (
                <Option key={meeting.id} value={meeting.id}>
                  {formatTimestamp(meeting.startDate)}
                </Option>
              ))}
            </Select>
          </Form.Item>
          </Col>
        </Row>
            <Form.Item
              name="criterion"
              label="Entregable o criterio de cumplimiento"
              rules={[
                {required: true,  message: "Por favor ingrese el entregable",},
              ]}
            >
              <TextArea
                 rows={3} 
                disabled={!allowEdit}
              />
            </Form.Item>
            <Form.Item
            name="responsible"
            label="Email del Responsable de cumplimiento"
            tooltip="Seleccione un responsable de la lista de invitados "
            rules={[
              { type: 'email', message: "Ingrese un email válido" },
              { required: true, message: "Por favor ingrese el responsable" },
            ]}
          >
            <Select
              placeholder="Seleccione un correo electrónico de la lista de invitados"
              disabled={!allowEdit}
            >
            {Array.isArray(currentMeeting?.meeting_guests) && currentMeeting.meeting_guests.map(invitee => {
              if (!invitee) return null;
              const {email} = invitee;
                return (
                  <Option key={email.trim()} value={email.trim()}>
                    {email.trim()}
                  </Option>
                );
              })
            }
            </Select>
          </Form.Item>
            <Form.Item
            name="executor"
            label="Email del Ejecutor asignado"
            tooltip="Ingrese el correo electrónico del ejecutor"
            rules={[
              { type: 'email', message: "Ingrese un email válido" },
            ]}
          >
            <Input
              placeholder="Ingrese el correo electrónico del ejecutor"
              disabled={!allowEdit}
            />
          </Form.Item>
        <Form.Item
          name="implementation"
          label="Implementación"
        >
          <Space direction="vertical">
            <Switch 
              checkedChildren="Si" 
              unCheckedChildren="No" 
              onChange={(value) => setImplementationData(value)}
              value={implementationData}
              disabled={!allowEdit}
            />
          </Space>
        </Form.Item>
        <Form.Item
          name="implementationDate"
          label="Fecha de Implementación"
        >
          <Input 
            type="date"
            disabled={!allowEdit}
          />
        </Form.Item>
        <Form.Item 
          name="observation"
          label="Observaciones de implementación" 
        >
          <TextArea 
            rows={3} 
            disabled={!allowEdit}
          />
        </Form.Item>
        <Row justify="end">
          <Col>
            <Button 
              style={{ marginRight: 8 }} 
              type="primary" 
              htmlType="submit"
              disabled={currentMeeting?.statusId > 2 || !allowEdit}
            >
              {isEdit ? "Guardar" : "Crear"}
            </Button>
            <Button style={{ marginRight: 8 }} onClick={handleCancel}>
              Cancelar
            </Button>
          </Col>
        </Row>
      </Form>
    </Modal>
  );
};

export default AgreementActionForm;
